import api from '@/api/jobApplicationManagement'

const state = {}

const actions = {
  // Micro Site
  searchMicroSite ({ commit }, condition) {
    return api.searchMicroSite(condition)
  },
  getMicroSiteById ({ commit }, id) {
    return api.getMicroSiteById(id)
  },
  createMicroSite ({ commit }, microSite) {
    return api.createMicroSite(microSite)
  },
  updateMicroSite ({ commit }, microSite) {
    return api.updateMicroSite(microSite)
  },

  // Question
  searchQuestion ({ commit }, condition) {
    return api.searchQuestion(condition)
  },
  getQuestionById ({ commit }, id) {
    return api.getQuestionById(id)
  },
  createQuestion ({ commit }, question) {
    return api.createQuestion(question)
  },
  updateQuestion ({ commit }, question) {
    return api.updateQuestion(question)
  },

  // Step
  searchStep ({ commit }, condition) {
    return api.searchStep(condition)
  },
  getStepById ({ commit }, id) {
    return api.getStepById(id)
  },
  createStep ({ commit }, step) {
    return api.createStep(step)
  },
  updateStep ({ commit }, step) {
    return api.updateStep(step)
  },

  // Questionnaire (Profile-side: loads active questionnaire list for invite)
  searchJobApplicationQuestionnaire ({ commit }, condition) {
    return api.searchQuestionnaire(condition)
  },

  // Questionnaire CRUD
  searchQuestionnaire ({ commit }, condition) {
    return api.searchQuestionnaire(condition)
  },
  getQuestionnaireById ({ commit }, id) {
    return api.getQuestionnaireById(id)
  },
  createQuestionnaire ({ commit }, questionnaire) {
    return api.createQuestionnaire(questionnaire)
  },
  updateQuestionnaire ({ commit }, questionnaire) {
    return api.updateQuestionnaire(questionnaire)
  },

  // Email Template (Profile-side + admin)
  searchEmailTemplate ({ commit }, condition) {
    return api.searchEmailTemplate(condition)
  },
  getEmailTemplateById ({ commit }, id) {
    return api.getEmailTemplateById(id)
  },
  sendTestEmail ({ commit }, emailTemplate) {
    return api.sendTestEmail(emailTemplate)
  },
  updateEmailTemplate ({ commit }, emailTemplate) {
    return api.updateEmailTemplate(emailTemplate)
  },

  // Invitation
  searchInvitation ({ commit }, condition) {
    return api.searchInvitation(condition)
  },
  updateInvitation ({ commit }, invitation) {
    return api.updateInvitation(invitation)
  },
  putInvitation ({ commit }, invitation) {
    return api.putInvitation(invitation)
  },
  createJobApplicationInvitation ({ commit }, invitation) {
    return api.createInvitation(invitation)
  },
  reactivateJobApplicationInvitation ({ commit }, invitation) {
    return api.reactivateJobApplicationInvitation(invitation)
  },
  createJobApplicationPdfExportTask ({ commit }, params) {
    return api.createJobApplicationPdfExportTask(params)
  },
  getJobApplicationPdfExportTaskStatus ({ commit }, params) {
    return api.getJobApplicationPdfExportTaskStatus(params)
  },
  exportInvitation ({ commit }, condition) {
    return api.exportInvitation(condition)
  }
}

const mutations = {}

const getters = {}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
